<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
  <div class="menu-board">
    <!-- 头部区域 -->
    <div class="header">
      <div class="header-left">
        <div class="stall-name-row">
          <div class="stall-name">{{ stallName }}</div>
          <div class="stall-divider"></div>
          <div class="stall-right">
            <div class="stall-slogan">新鲜 · 营养 · 美味</div>
            <div class="stall-tags">
              <span class="tag-item">
                <i class="el-icon-success"></i> 新鲜食材
              </span>
              <span class="tag-item">
                <i class="el-icon-success"></i> 营养均衡
              </span>
              <span class="tag-item">
                <i class="el-icon-success"></i> 美味可口
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="header-right">
        <!-- <i class="el-icon-time"></i> -->
        <span>{{ currentDate }} {{ currentTime }}</span>
      </div>
    </div>

    <!-- 菜品卡片区（每页最多 2 张，多于 2 个自动轮播，单个自动撑开） -->
    <transition name="fade" mode="out-in">
      <div class="main-content" :key="page">
        <div
          class="food-card"
          :class="{ single: visibleItems.length === 1, 'sold-out': item.sold_out === 1 }"
          v-for="(item, index) in visibleItems"
          :key="item.id"
        >
        <!-- 编号 -->
        <div class="card-index">{{ String(index + 1).padStart(2, '0') }}</div>

        <!-- 卡片主体：左图右文 -->
        <div class="card-body">
          <div class="card-image">
            <img :src="item.image || defaultImage" :alt="item.name" />
            <!-- 售罄遮罩：sold_out === 1 时显示 -->
            <div class="sold-out-mask" v-if="item.sold_out === 1">
              <span class="sold-out-text">售罄</span>
            </div>
          </div>
          <div class="card-info">
            <div class="food-name">{{ item.name }}</div>
            <div class="food-price">
              <span class="price-symbol">¥</span>
              <span class="price-value">{{ item.price }}</span>
              <span class="price-unit">/份</span>
            </div>
          </div>
        </div>

        <!-- 库存信息区 -->
        <div class="card-inventory">
          <div class="inventory-item">
            <div class="inventory-label">总数量</div>
            <div class="inventory-value green">{{ item.total }}<span class="inventory-unit">份</span></div>
          </div>
          <div class="inventory-item">
            <div class="inventory-label">剩余数量</div>
            <!-- 售罄时显示售罄印章 -->
            <div class="inventory-value sold-out-value" v-if="item.sold_out === 1">售罄</div>
            <div class="inventory-value orange" v-else>{{ item.remaining }}<span class="inventory-unit">份</span></div>
          </div>
        </div>
      </div>
      </div>
    </transition>

    <!-- 底部信息栏 -->
    <div class="footer">
      <div class="footer-left">
        <i class="el-icon-volume-up"></i>
        <span>温馨提示：请按需取餐，珍惜粮食，杜绝浪费</span>
      </div>
      <!-- <div class="footer-right">
        <i class="el-icon-time"></i>
        <span>营业时间：10:30 - 20:30</span>
      </div> -->
    </div>
  </div>
  </v-scale-screen>
</template>

<script>
import { getTodayDishes } from "../api/api";
export default {
  name: "MenuBoard",
  data() {
    return {
      // 档口名称（默认"2号档口"，后端 stall_name 有值时覆盖）
      stallName: "2号档口",
      // 默认图片：菜品 image 为空时兜底
      defaultImage:
        "https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260819/ec502ef7265a0998b3672eab19618627.png",
      currentDate: "",
      currentTime: "",
      timer: null,
      carouselTimer: null,
      // 每页最多展示的菜品数
      perPage: 2,
      // 当前页（从 0 开始）
      page: 0,
      foodList: [],
    };
  },
  computed: {
    // 总页数（每页最多 2 个菜品）
    totalPages() {
      return Math.ceil(this.foodList.length / this.perPage) || 1;
    },
    // 当前页展示的菜品
    visibleItems() {
      const start = this.page * this.perPage;
      return this.foodList.slice(start, start + this.perPage);
    },
  },
  mounted() {
    this.getTodayDishes()
    this.updateDateTime();
    this.timer = setInterval(this.updateDateTime, 5000);
    this.startCarousel();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.stopCarousel();
  },
  methods: {    
    // 从当前页面 URL 解析 query 参数（不依赖 vue-router）
    parseUrlParams() {
      const params = {};
      const search = window.location.search;
      if (!search) return params;
      const pairs = search.substring(1).split('&');
      pairs.forEach((pair) => {
        if (!pair) return;
        const [key, value] = pair.split('=');
        if (key) {
          params[decodeURIComponent(key)] = value
            ? decodeURIComponent(value)
            : '';
        }
      });
      return params;
    },
    async getTodayDishes() {
      const query = this.parseUrlParams();
      const params = {
        shop_id: query.shop_id,
        date: query.date || null,
        stall_name: query.stall_name,
        meal_name: query.meal_name
      };
      try {
        const res = await getTodayDishes(params);
        console.log(res, 'getTodayDishes');
        // 后端业务数据体（axios 的 res.data 为后端 JSON，业务字段在其 data 下）
        const biz = res && res.data && res.data.data;
        if (!biz) return;

        // 档口名称：后端 stall_name 没有值或为空时保留默认值
        if (biz.stall_name && biz.stall_name.trim()) {
          this.stallName = biz.stall_name.trim();
        }

        // 后端菜品数组 dishes（每项 { dish_name, image, initial_quantity, price,
        // remaining_quantity, sold_out, sold_quantity, stock_record_id }）
        // 映射为页面使用的 foodList 结构
        const dishes = biz.dishes;
        if (Array.isArray(dishes) && dishes.length) {
          this.foodList = dishes.map((d, index) => ({
            // 后端无 id 时按下标生成，保证 :key 可用
            id: d.stock_record_id != null ? d.stock_record_id : index + 1,
            name: d.dish_name || d.name || '未知菜品',
            // 后端 price 为字符串，与 mock 保持一致
            price: d.price != null ? d.price : '0',
            // initial_quantity：总数量
            total: d.initial_quantity != null ? d.initial_quantity : 0,
            // remaining_quantity：剩余数量
            remaining: d.remaining_quantity != null ? d.remaining_quantity : 0,
            image: d.image || '',
            // sold_out：1 表示售罄
            sold_out: d.sold_out,
            sold_quantity: d.sold_quantity != null ? d.sold_quantity : 0
          }));
          this.page = 0;
          // 数据更新后按条数重新决定是否轮播
          this.startCarousel();
        }
      } catch (e) {
        // 请求失败时保留页面内置的 mock 数据兜底
        console.error('获取今日菜品失败：', e);
      }
    },
    // 开启菜品自动轮播（多于 2 个时每 5 秒切换一页）
    startCarousel() {
      this.stopCarousel();
      if (this.totalPages > 1) {
        this.carouselTimer = setInterval(() => {
          this.page = (this.page + 1) % this.totalPages;
        }, 5000);
      }
    },
    // 停止轮播
    stopCarousel() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }
    },
    updateDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const weekDays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      const weekDay = weekDays[now.getDay()];
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      this.currentDate = `${year}-${month}-${day} ${weekDay}`;
      this.currentTime = `${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style scoped>
/* ==================== 基础重置 ==================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.menu-board {
  width: 1920px;
  height: 1080px;
  background-color: #155730;
  display: flex;
  flex-direction: column;
  font-family: "Microsoft YaHei", "PingFang SC", "Helvetica Neue", Arial,
    sans-serif;
  color: #ffffff;
  overflow: hidden;
}

/* ==================== 背景装饰 ==================== */
.menu-board::before {
  content: "";
  position: absolute;
  top: -80px;
  right: -100px;
  width: 600px;
  height: 600px;
  background: radial-gradient(
    circle,
    rgba(45, 130, 70, 0.5) 0%,
    transparent 70%
  );
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

.menu-board::after {
  content: "";
  position: absolute;
  bottom: -150px;
  right: 100px;
  width: 500px;
  height: 500px;
  background: radial-gradient(
    circle,
    rgba(30, 100, 55, 0.4) 0%,
    transparent 70%
  );
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

/* ==================== 头部区域 ==================== */
.header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 36px 48px 28px;
}

.header-left {
  display: flex;
  flex-direction: column;
}

.stall-name-row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.stall-name {
  font-size: 68px;
  font-weight: 900;
  letter-spacing: 4px;
  line-height: 1;
  white-space: nowrap;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.stall-divider {
  width: 3px;
  height: 56px;
  background-color: rgba(255, 255, 255, 0.6);
  margin-top: 10px;
  border-radius: 2px;
}

.stall-right {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 6px;
}

.stall-slogan {
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 6px;
  color: rgba(255, 255, 255, 0.95);
}

.stall-tags {
  display: flex;
  gap: 20px;
}

.tag-item {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  gap: 4px;
}

.tag-item .el-icon-success {
  color: #6fd68a;
  font-size: 16px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  /* background-color: rgba(255, 255, 255, 0.08); */
  padding: 10px 20px;
  border-radius: 8px;
  white-space: nowrap;
}

.header-right .el-icon-time {
  font-size: 26px;
}

/* ==================== 主内容区（卡片收窄居中，不再撑满整屏） ==================== */
.main-content {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 0 48px;
}

/* ==================== 菜品卡片（等比放大 1.5 倍） ==================== */
.food-card {
  flex: 0 1 930px;
  min-width: 0;
  min-height: 700px;
  background-color: #ffffff;
  border-radius: 30px;
  padding: 33px 19px 36px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;
  color: #1a1a1a;
}

/* 单个菜品时卡片自动撑开占满 */
.food-card.single {
  flex: 1;
}

/* 单菜品时内容左对齐，避免居中显得空旷 */
.food-card.single .card-body {
  justify-content: flex-start;
  padding-left: 40px;
}

/* 轮播切换淡入淡出 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 编号标签 */
.card-index {
  position: absolute;
  top: 30px;
  left: 36px;
  background-color: #155730;
  color: #ffffff;
  font-size: 30px;
  font-weight: 700;
  padding: 9px 24px;
  border-radius: 15px;
  line-height: 1;
  z-index: 2;
}

/* 卡片主体：左图右文（等比放大 1.5 倍，撑满中间区域使卡片更高更饱满） */
.card-body {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 36px;
  /* padding-top: 42px; */
}

.card-image {
  width: 280px;
  height: 230px;
  border-radius: 18px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f8f8f5;
  border: 1px solid #eef0ea;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 售罄遮罩：盖在图片上 */
.sold-out-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(21, 87, 48, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.sold-out-text {
  font-size: 48px;
  font-weight: 900;
  color: #ffffff;
  background: #e43c2a;
  padding: 12px 36px;
  border-radius: 16px;
  letter-spacing: 8px;
  box-shadow: 0 6px 18px rgba(228, 60, 42, 0.45);
  transform: rotate(-10deg);
}

/* 售罄卡片：图片置灰 + 价格置灰 */
.food-card.sold-out .card-image img {
  filter: grayscale(0.7);
}

.food-card.sold-out .food-price .price-symbol,
.food-card.sold-out .food-price .price-value {
  color: #b5b5b5;
}

/* 售罄时剩余数量处的印章样式 */
.inventory-value.sold-out-value {
  font-size: 56px;
  font-weight: 900;
  letter-spacing: 12px;
  text-indent: 12px;
  line-height: 1;
  color: #e43c2a;
  background: rgba(228, 60, 42, 0.06);
  border: 6px solid #e43c2a;
  border-radius: 18px;
  padding: 10px 34px 14px;
  margin-top: 22px;
  transform: rotate(-6deg);
  box-shadow:
    0 8px 20px rgba(228, 60, 42, 0.25),
    inset 0 0 16px rgba(228, 60, 42, 0.12);
}

.card-info {
  /* 固定宽度：菜名长短不影响整体布局，图片与文字位置保持稳定 */
  width: 500px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 21px;
}

.food-name {
  font-size: 54px;
  font-weight: 700;
  line-height: 1.5;
  color: #1a1a1a;
  /* letter-spacing: 1.5px; */
  /* 固定为两行高度：菜名长短不同也不影响卡片高度 */
  min-height: 3em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
}

.food-price {
  display: flex;
  align-items: baseline;
  gap: 3px;
}

.price-symbol {
  font-size: 30px;
  font-weight: 700;
  color: #e85d2a;
}

.price-value {
  font-size: 62px;
  font-weight: 800;
  color: #e85d2a;
  line-height: 1;
  letter-spacing: -1px;
}

.price-unit {
  font-size: 21px;
  color: #999999;
  margin-left: 6px;
}

/* ==================== 库存信息区 ==================== */
.card-inventory {
  display: flex;
  background-color: #f1f5f3;
  border-radius: 21px;
  padding: 30px 0 24px;
  box-shadow: inset 0 3px 12px rgba(21, 87, 48, 0.06);
}

.inventory-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.inventory-item:first-child {
  border-right: 1px solid #e0e7e2;
}

.inventory-label {
  font-size: 36px;
  font-weight: 700;
  color: #4a5a50;
  letter-spacing: 3px;
}

.inventory-value {
  font-size: 130px;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -1px;
}

.inventory-value.green {
  color: #155730;
}

.inventory-value.orange {
  color: #e8752a;
}

.inventory-unit {
  font-size: 31px;
  color: #333333;
  margin-left: 12px;
}

/* ==================== 底部信息栏 ==================== */
.footer {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 48px 40px;
}

.footer-left,
.footer-right {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 35px;
  color: rgba(255, 255, 255, 0.85);
}

.footer-left .el-icon-volume-up,
.footer-right .el-icon-time {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.9);
}

/* ==================== 适配说明 ==================== */
/* 页面固定以 1920x1080 设计稿渲染，由外层 v-scale-screen 组件自动等比缩放适配各分辨率屏幕 */
</style>